import { Icon, TextButton } from '@/shared/ui'

import { useFilter } from '../../model/filter'

export const ResetButton = () => {
  const { resetFilter } = useFilter()

  const handleClick = () => {
    resetFilter()
  }

  return (
    <TextButton size="large" onClick={handleClick}>
      <Icon name="reset" />
      초기화
    </TextButton>
  )
}
